export default __webpack_public_path__ + "static/media/679.cb58517e.png";